module.exports = __webpack_public_path__ + "media/svg/CheckSquareFill-secondary-b5701419.svg";